import React from 'react'

const LoadingSpinner = (props) => {
  const {
    withOverlay = false,
    width = '100px',
    height = '100px'
  } = props

  const spinner = (
    <div
      style={{
        opacity: 0.6,
        content: `url(${require('images/spinner.svg')})`,
        margin: '0 auto',
        width,
        height
      }}
    />
  )

  const spinnerWithOverlay = (
    <div
      style={{
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        position: 'absolute',
        zIndex: '99',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        top: 0,
        left: 0
      }}
    >
      {spinner}
    </div>
  )

  return withOverlay ? spinnerWithOverlay : spinner
}

export default LoadingSpinner
